export default {
	active: false,
	regions: [],
	horizontals: [],
	horizontalPixels: [],
	verticals: [],
	edgeTolerancePixels: 10,
	regionGuides: false,
	horizontalGuides: false,
	verticalGuides: false,
	guideContainer: null,
	guideGraphic: null,

	setGuideContainer(c) {
		this.guideContainer = c;
	},

	clear() {
		this.regions = [];
		this.horizontals = [];
		this.horizontalPixels = [];
		this.verticals = [];
		this.verticalPixels = [];

		if (this.guide) {
			this.guide.clear();
		}
	},

	tick() {
		if (!this.active) {
			return;
		}
		this._createAreas();
		(this._createPixels(), this._drawGuides());
	},

	add(x, y, w, h, scale) {
		x = Math.round(x);
		y = Math.round(y);
		w = Math.round(w * scale);
		h = Math.round(h * scale);
		this.regions.push([Math.round(x - w / 2), Math.round(y - h / 2), w, h]);
	},

	hasHit(x, y) {
		if (this.horizontalPixels[x] && this.horizontalPixels[x][y]) {
			return 1;
		}

		if (this.verticalPixels[x] && this.verticalPixels[x][y]) {
			return 2;
		}

		return 0;
	},

	_createAreas() {
		for (let i = 0; i < this.regions.length; i++) {
			//Top edge:
			this.horizontals.push([
				this.regions[i][0], //x
				this.regions[i][1], //y
				this.regions[i][2], //width
				this.edgeTolerancePixels //height
			]);

			//Bottom edge:
			this.horizontals.push([
				this.regions[i][0],
				this.regions[i][1] + this.regions[i][3] - this.edgeTolerancePixels,
				this.regions[i][2],
				this.edgeTolerancePixels
			]);

			//Left edge:
			this.verticals.push([this.regions[i][0], this.regions[i][1], this.edgeTolerancePixels, this.regions[i][3]]);

			//Right edge:
			this.verticals.push([
				this.regions[i][0] + this.regions[i][2] - this.edgeTolerancePixels,
				this.regions[i][1],
				this.edgeTolerancePixels,
				this.regions[i][3]
			]);
		}
	},

	_createPixels() {
		for (let i = 0; i < this.horizontals.length; i++) {
			//x row
			for (let x = this.horizontals[i][0]; x <= this.horizontals[i][0] + this.horizontals[i][2]; x++) {
				if (!this.horizontalPixels[x]) {
					this.horizontalPixels[x] = [];
				}

				for (let y = this.horizontals[i][1]; y <= this.horizontals[i][1] + this.horizontals[i][3]; y++) {
					this.horizontalPixels[x][y] = 1;
				}
			}
		}

		for (let i = 0; i < this.verticals.length; i++) {
			//x row
			for (let x = this.verticals[i][0]; x <= this.verticals[i][0] + this.verticals[i][2]; x++) {
				if (!this.verticalPixels[x]) {
					this.verticalPixels[x] = [];
				}

				for (let y = this.verticals[i][1]; y <= this.verticals[i][1] + this.verticals[i][3]; y++) {
					this.verticalPixels[x][y] = 1;
				}
			}
		}

	},

	_drawGuides() {
		if (this.regionGuides) {
			for (let i = 0; i < this.regions.length; i++) {
				this._drawGuidBlock(this.regions[i], 0x9b59b6);
			}
		}

		if (this.horizontalGuides) {
			for (let i = 0; i < this.horizontals.length; i++) {
				this._drawGuidBlock(this.horizontals[i], 0xf1c40f);
			}
		}

		if (this.verticalGuides) {
			for (let i = 0; i < this.verticals.length; i++) {
				this._drawGuidBlock(this.verticals[i], 0xe74c3c);
			}
		}
	},

	_drawGuidBlock(region, colour) {
		if (!this.guide) {
			this.guide = new PIXI.Graphics();
			this.guideContainer.addChild(this.guide);
			this.guideContainer.alpha = 0.5;
		}

		this.guide.beginFill(colour);
		this.guide.drawRect(region[0], region[1], region[2], region[3]);
		this.guide.endFill();
	}
};
